import { captureError } from "@internal/error-handling";
import {
  type ReplicationHandle,
  type SyncState,
  startReplication,
} from "@internal/replication";
import { BehaviorSubject } from "rxjs";
import { getDbForUser } from "./db";

const state$ = new BehaviorSubject<SyncState>({
  connection: "connected",
  pending: false,
  lastInSyncAt: null,
});

/** Drives the sync indicator. See @internal/replication's SyncState. */
export const syncState$ = state$.asObservable();

let handle: ReplicationHandle | null = null;
let started = false;

export function startReplicationOnAuth(): void {
  if (started) return;
  started = true;

  const disabled =
    typeof window !== "undefined" &&
    (window as { __E2E_NO_REPLICATION__?: boolean }).__E2E_NO_REPLICATION__ ===
      true;
  if (disabled) {
    console.log("[rxdb] replication disabled (__E2E_NO_REPLICATION__)");
  }

  handle = startReplication({
    table: "week_allowance",
    getCollection: async (userId) =>
      (await getDbForUser(userId)).week_allowance,
    // Sentry, not the global error screen. This used to be reportGlobalError,
    // which blanked the whole app on a transient sync failure — now that the
    // indicator reports it in place, that is both harsh and redundant.
    onError: captureError,
    disabled,
  });

  handle.syncState$.subscribe((s) => state$.next(s));
}

export async function awaitInitialReplication(): Promise<void> {
  if (!handle) return;
  await handle.awaitInitialReplication();
}

export function getReplicationErrors(): string[] {
  return handle?.getErrors() ?? [];
}

export function clearReplicationErrors(): void {
  handle?.clearErrors();
}
